const env_name = process.env.env_name

const env_default = require(`./env_default.js`)
const env_development = require(`./env_development.js`)
const env_production = require(`./env_production.js`)

console.log(process.env.NODE_ENV)
console.log(process.env.env_name)

const env_config = env_name == 'development' ? env_development : env_name == 'production' ? env_production : env_default

module.exports = {
    title: `SBH 연구인프라 통합관리시스템`,
    description: `서울바이오허브 연구인프라통합관리시스템`,
    defaultKeywords: ['collabi', 'react', 'gatsby', `tailwindcss`],
    author: '㈜콜라비',
    lang: 'ko',
    applyAuthMenu: false,

    // 환경 변수를 바탕으로한 설정으로 변경
    serverUrl: env_config.serverUrl,
    serverPrefixUrl: env_config.serverPrefixUrl,
    loginMaintainenceTime: env_config.loginMaintainenceTime,
    excuteAlarmTime : env_config.excuteAlarmTime,

    // 로컬 정보
    //  serverUrl:
    //  process.env.NODE_ENV !== 'production'
    //          ? `http://localhost:8080`
    //          : `http://localhost:8080`,
    //  serverPrefixUrl: '/tree',
    //  loginMaintainenceTime: 10800,
    //  excuteAlarmTime : 300,

    // 개발 서버
    // serverUrl:
    //     process.env.NODE_ENV !== 'production'
    //         ? `http://211.54.28.111`
    //         : `http://211.54.28.111`,
    // serverPrefixUrl: '/tree',
    // loginMaintainenceTime: 10800,
    // excuteAlarmTime : 300,
    
    // 개발 정보 (sbh)
    //    serverUrl:
    //    process.env.NODE_ENV !== 'production'
    //        ? `http://192.168.0.89:8080`
    //        : `http://192.168.0.89:8080`,
    //    serverPrefixUrl: '/tree',
    //    loginMaintainenceTime: 10800,
    //    excuteAlarmTime : 300,

    // 개발 정보 (sbh2021)
    // serverUrl:
    // process.env.NODE_ENV !== 'production'
    //     ? `https://sbh2021.collabi.co.kr`
    //     : `https://sbh2021.collabi.co.kr`,
    // serverPrefixUrl: '',
    // loginMaintainenceTime: 10800,
    // excuteAlarmTime : 300,

    // 운영 정보
    //   serverUrl:
    //   process.env.NODE_ENV !== 'production'
    //       ? `https://www.seoulbiohub.kr`
    //       : `https://www.seoulbiohub.kr`,
    //   serverPrefixUrl: '/tree',
    //   loginMaintainenceTime: 10800,
    //   excuteAlarmTime : 300,
}